// extracted by mini-css-extract-plugin
module.exports = {"loading":"StandardLayout-module_loading_xYQUI"};